import { Component, Injector, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { AuthService } from "./services/user/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "EEA-eMONITOR";
  private isMobileMenuOpen = false;
  isSearchBanner: boolean = false;
  logoUrl: string = "./assets/img/Mepa_environmental-monitor-logo.png";
  private authService: AuthService;
  url = "";

  constructor(private renderer: Renderer2, private router: Router, public _injector: Injector, private route:ActivatedRoute) {
    this.authService = this._injector.get(AuthService);
  }
  
  ngOnInit(): void {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (
          this.ShowDatabaseLogo(event)
        ) {
          console.log("navigation started");
          this.isSearchBanner = true;
          this.logoUrl = "./assets/img/Mepa_Database-logo.png";
        } else {
          this.isSearchBanner = false;
          this.logoUrl = "./assets/img/Mepa_environmental-monitor-logo.png";
        }
      }
      this.url = window.location.href.replace(window.location.hash, "");
    });
    this.authService.LoginAnonymous();
  }

  private ShowDatabaseLogo(event: NavigationStart) {
    return event.url == "/search" ||
      event.url == "/searchPublication" ||
      event.url == "/recentDecisions";
  }

  ShowMobileMenu() {
    const showMenu = "show-menu";
    if (this.isMobileMenuOpen) {
      this.renderer.removeClass(document.body, showMenu);
      this.isMobileMenuOpen = false;
    } else {
      this.renderer.addClass(document.body, showMenu);
      this.isMobileMenuOpen = true;
    }
  }
}
